export default {
  namespaced: true,
  actions: {
    create({ commit }, achievement) {
      return Vue.$http.post('candidate/achievements', { achievement })
    },
    destroy({ commit }, id) {
      return Vue.$http.delete(`candidate/achievements/${id}`)
    },
    update({ commit }, achievement) {
      return Vue.$http.patch(`candidate/achievements/${achievement.id}`, {
        achievement
      })
    }
  }
}
